import { render } from "./form-new-document.vue?vue&type=template&id=019d50b7"
import script from "./form-new-document.vue?vue&type=script&lang=js"
export * from "./form-new-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__